import cn from 'classnames'
import React, { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import BackNavLink, { BackNavLinkProps } from './BackNavLink'
import Icon from 'core/components/icons/Icon'

export type Breadcrumb =
  | string
  | {
      to?: string
      loading?: boolean
      label: ReactNode
      onClick?: VoidFunction
    }

export interface BreadcrumbsProps {
  crumbs: Breadcrumb[]
  classname?: string
  backProps?: BackNavLinkProps
}

const Breadcrumbs = ({ crumbs, classname, backProps }: BreadcrumbsProps) => {
  return (
    <div
      className={cn([
        'everlance-breadcrumbs flex items-center overflow-hidden gap-4 text-dark-4 p-7 md:p-0',
        classname
      ])}
    >
      {backProps && <BackNavLink {...backProps} />}
      {crumbs?.map((crumb, idx) => {
        const isLast = crumbs.length === idx + 1

        if (typeof crumb === 'string') {
          return (
            <React.Fragment key={`${crumb}_${idx}_label`}>
              <span className="cursor-default text-lg md:text-base whitespace-nowrap">
                {crumb}
              </span>
              {!isLast && <Icon name="right" noWrapper size={10} />}
            </React.Fragment>
          )
        }

        const { to, loading, label, onClick } = crumb

        const content = loading ? (
          <Icon name="loading" noWrapper size={14} />
        ) : (
          label
        )
        return (
          <React.Fragment key={`${label}_${to}_${idx}_label`}>
            <span
              className={cn([
                'cursor-default whitespace-nowrap last:font-semibold truncate',
                (to || !!onClick) &&
                  !loading &&
                  'hover:text-primary cursor-pointer'
              ])}
              onClick={() => {
                onClick?.()
              }}
            >
              {to ? (
                <Link
                  to={to}
                  className="text-dark-4 text-base hover:text-primary"
                >
                  {content}
                </Link>
              ) : (
                content
              )}
            </span>
            {!isLast && <Icon name="right" noWrapper size={10} />}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default Breadcrumbs
